import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import moment from "moment/moment";
import { tableStyles } from "../../../../commons/table/tableConfig";

const SiniestralidadTrabajadorTable = ({ data, loading }) => {
  const columns = [
    {
      header: "Siniestro",
      accessorKey: "siniestroART",
      grow: 1,
      enableColumnActions: false,
    },
    {
      header: "Nro. Predenuncia",
      accessorKey: "nroPreDenuncia",
      grow: 1,
      enableColumnActions: false,
    },
    {
      header: "Tipo Siniestro",
      accessorKey: "tipoSiniestro",
      grow: 2,
      enableColumnActions: false,
    },
    {
      header: "Fecha de Ocurrencia",
      accessorKey: "fechaOcurrencia",
      grow: 1,
      enableColumnActions: false,
      render: (rowData) => {
        return moment(rowData.fechaOcurrencia).format("DD/MM/YYYY");
      },
    },
    {
      header: "Diagnóstico Principal",
      accessorKey: "diagnostico",
      grow: 3,
      enableColumnActions: false,
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={data}

      layoutMode="grid"
      state={{ isLoading: loading }}
      localization={MRT_Localization_ES}
      initialState={{ showColumnFilters: true }}
      style={{ ...tableStyles.container }}
      enableToolbarInternalActions={false}
      enableTopToolbar={false}
    />
  );
};

export default SiniestralidadTrabajadorTable;
